angular
  .module('data-ng-todos')
  .factory('loadAppointmentDetailsCommand', function loadAppointmentDetailsCommand(defineCommand, $http) {
    return defineCommand(
      'loadAppointmentDetailsCommand',
      function loadAppointmentDetailsCommand(deferred, eventId, appointmentId) {
        $http
          .get('ssccampus/appointment/' + appointmentId)
          .then(function ({ data }) {
            deferred.resolve(data);
          })
          .catch(function ({ error }) {
            deferred.reject(error);
          });
      }
    );
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/load_appointment_details_command.es.js